import React from "react";
import { Category } from "types/category";
import { SubCategory } from "types/subCategory";
import type { ListingCategoryDetail, ListingDetailKind } from "./CategoryData/types";
import Assistance from "./CategoryData/Assistance";
import ChildCare from "./CategoryData/ChildCare";
import Gardening from "./CategoryData/Gardening";
import Handiwork from "./CategoryData/Handiwork";
import HouseKeeping from "./CategoryData/HouseKeeping";
import Tutoring from "./CategoryData/Tutoring";

/**
 * Renders category-specific detail blocks for public ad and service pages.
 */
export function renderListingCategoryData(
    category: string | undefined,
    subcategory: string | undefined,
    detail: ListingCategoryDetail,
    kind: ListingDetailKind = "service"
): React.ReactElement {
    if (category === Category.CHILDCARE.toString()) {
        return <ChildCare />;
    }

    switch (subcategory) {
        case SubCategory.TROUBLESHOOTING:
        case SubCategory.ADMINISTRATIVE:
        case SubCategory.INTERNET_USE:
            return <Assistance detail={detail} kind={kind} />;
        case SubCategory.PLANTATION:
        case SubCategory.TERRACE:
        case SubCategory.TRIMMING:
        case SubCategory.OUTDOOR_CLEANING:
            return <Gardening detail={detail} kind={kind} />;
        case SubCategory.SIMPLE:
        case SubCategory.INSTALLATION:
            return <Handiwork detail={detail} kind={kind} />;
        case SubCategory.CLEANING:
        case SubCategory.IRONING:
        case SubCategory.LAUNDRY:
            return <HouseKeeping detail={detail} kind={kind} />;
        case SubCategory.HOMEWORK:
        case SubCategory.FOREIGN_LANGUAGES:
        case SubCategory.OTHER_LESSON:
            return <Tutoring detail={detail} kind={kind} />;
        default:
            return <></>;
    }
}
